// @ts-check
import PropTypes from 'prop-types';

import OrgLocationSection from './OrgLocationSection';
import OrgContactsSection from './OrgContactsSection';
import OrgFundingSection from './OrgFundingSection';
import OrgTradeshowsSection from './OrgTradeshowsSection';
import OrgClinicalTrialsSection from './OrgClinicalTrialsSection';
import OrgAdvancedSection from './OrgAdvancedSection';
import OrgListsSection from './OrgListsSection';

// SCIL-17770: the collapsible filter sections shared by BOTH the People and
// Activity panels. Rendering the same stack from both panels gives parity by
// construction — the two tabs cannot drift. Every section binds to the shared
// `filters[orgId]` slice, so a value set on one tab is visible on the other.
//
// Section order mirrors the main-search filter panel
// (components/Search/Filters/index.js): Location, Contacts, Funding,
// Tradeshows, Clinical Trials, Lists, Advanced. Sections with no org-page
// equivalent (Organisation, Venture Capital, Acquisitions) are omitted.

const OrgFilterSections = ({ organisationId, loading }) => (
  <>
    <OrgLocationSection organisationId={organisationId} loading={loading} />
    <OrgContactsSection organisationId={organisationId} loading={loading} />
    <OrgFundingSection organisationId={organisationId} loading={loading} />
    <OrgTradeshowsSection organisationId={organisationId} loading={loading} />
    <OrgClinicalTrialsSection
      organisationId={organisationId}
      loading={loading}
    />
    <OrgListsSection organisationId={organisationId} loading={loading} />
    <OrgAdvancedSection organisationId={organisationId} loading={loading} />
  </>
);

OrgFilterSections.propTypes = {
  organisationId: PropTypes.number.isRequired,
  loading: PropTypes.bool,
};

export default OrgFilterSections;
